import { render, staticRenderFns } from "./storefront.vue?vue&type=template&id=c0b1dcb2&"
import script from "./storefront.vue?vue&type=script&lang=js&"
export * from "./storefront.vue?vue&type=script&lang=js&"
import style0 from "./storefront.vue?vue&type=style&index=0&id=c0b1dcb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports